// extracted by mini-css-extract-plugin
module.exports = {"marker":"styles_marker__YLpQ6","head":"styles_head__qGF1q","stick":"styles_stick__Eh686","shadow":"styles_shadow__K_94_","hover":"styles_hover__h1Dbt"};